import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  container: {
    padding: 8,
    borderRadius: 8,
    borderWidth: 1,
    marginHorizontal: Platform.select({
      web: 12,
      default: 6,
    }),
    marginTop: 16,
  },
  image: {
    aspectRatio: 1.7,
    borderRadius: 2,
    marginBottom: 8,
  },
  containerStyle: {
    marginHorizontal: 0,
    marginVertical: 0,
  },
  placeholderStyle: {
    margin: 0,
  },
  result: {
    textAlign: 'center',
    width: '100%',
    marginVertical: 6,
    paddingHorizontal: 4,
    fontSize: 16,
  },
});
